import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptTransactions} from "./transactions.adapter";
import type {TransactionsApiResponse, TransactionsFilter, TransactionsResult} from "./transactions.types";

export const getTransactionsService = async (filter: TransactionsFilter): Promise<TransactionsResult> => {
  const response = await httpRequest<TransactionsApiResponse>({
    method: "GET",
    url: "/user/transaction-history",
    baseUrl: config.walletApiUrl,
    query: {
      type: filter.type,
      page: filter.page,
      limit: filter.limit,
      sort: filter.sort ?? "desc",
      direction: filter.direction,
    },
  });
  return adaptTransactions(response);
};
